import { render, staticRenderFns } from "./RainEstimationTable.vue?vue&type=template&id=2387ce6d&scoped=true"
import script from "./RainEstimationTable.vue?vue&type=script&lang=js"
export * from "./RainEstimationTable.vue?vue&type=script&lang=js"
import style0 from "./RainEstimationTable.vue?vue&type=style&index=0&id=2387ce6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387ce6d",
  null
  
)

export default component.exports